module.exports = __webpack_public_path__ + "img/feature_b06.021a05a2.svg";